export default __webpack_public_path__ + "static/media/wave-desktop.2fe84cb6.svg";